<template>
  <div class="card card-secondary card-outline mb-4 mt-4">
    <!--begin::Header-->
    <div class="card-header"><div class="card-title">{{ cardTitle }}</div></div>
    <!--end::Header-->
    <!--begin::Form-->
    <errorAlert v-if="hasError" :alertMessage="message" :errorNumber="errorNumber" />
    <successAlert v-if="hasSucess" :message="message" />

    <form @submit.prevent="subimtData()">
      <!--begin::Body-->
      <div class="card-body">
        <div class="row">
          <div class="col-12 col-sm-6 mb-3">
            <label for="" class="form-label">اسم الخدمة - عربي:</label>
            <input type="text" v-model="name" class="form-control">
          </div>
          <div class="col-12 col-sm-6 mb-3">
            <label for="" class="form-label">اسم الخدمة - انجليزي:</label>
            <input type="text" v-model="nameEn" class="form-control english-input">
          </div>
        </div>
        <!-- Category + Status -->
        <div class="row">
          <div class="col-12 col-sm-6 mb-3">
            <label class="form-label">نوع الخدمة (التصنيف):</label>
            <select v-model="category" class="form-control">
              <option value="" disabled>— اختر نوع الخدمة —</option>
              <option
                v-for="(label,key) in filteredCategoryChoices"
                :key="key"
                :value="key">
                {{ label }}
              </option>
            </select>
            <small class="text-muted" style="font-size:11px;">
              حدد أي نوع طلب تظهر فيه هذه الخدمة
            </small>
          </div>
           <div class="col-12 col-sm-6 mb-3">
            <label for="" class="form-label">الحالة:</label>
            <select v-model="isActive" class="form-control">
              <option :value="true">نشط</option>
              <option :value="false">غير نشط</option>
            </select>
          </div>
        </div> 
        <div class="row">
          <div class="col-12 col-sm-6 mb-3">
            <div class="form-check">
              <input v-model="hasHandPrice" class="form-check-input" type="checkbox" :value="true" id="hasHandPrice">
              <label class="form-check-label" for="hasHandPrice">
                يستطيع المزود إضافة قيمة شغل اليد
              </label>
            </div>
          </div>
          <div class="col-12 col-sm-6 mb-3">
            <div class="form-check">
              <input v-model="hasPartsPrice" class="form-check-input" type="checkbox" :value="true" id="hasPartsPrice">
              <label class="form-check-label" for="hasPartsPrice">
                يستطيع المزود إضافة قيمة قطع الغيار
              </label>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-12 col-sm-6 mb-3">
            <div class="form-check">
              <input v-model="isPhoto" class="form-check-input" type="checkbox" :value="true" id="isPhoto">
              <label class="form-check-label" for="isPhoto">
                خدمة مخصصة لتصوير العقارات
              </label>
            </div>
          </div>
        </div>

        <!-- <div class="row">
          <div class="col-12 col-sm-6 mb-3">
            <label for="" class="form-label">سعر الخدمة العادية:</label>
            <input type="number" v-model="price" class="form-control">
          </div>
          <div class="col-12 col-sm-6 mb-3">
            <label for="" class="form-label">سعر الخدمة السريعة:</label>
            <input type="number" v-model="priceFast" class="form-control">
          </div>
        </div> -->
      </div>
      <!--end::Body-->
      <!--begin::Footer-->
      <div class="card-footer">
        <div class="row">
          <div class="col text-end">
            <button v-if="!formLoader" type="submit" class="btn btn-success">ارسل</button>
            <loader v-if="formLoader" />
          </div>
        </div>
      </div>
      <!--end::Footer-->
    </form>
    <!--end::Form-->
  </div>
</template>

<script>
import { toast } from '@/helpers/tools';

export default {
  name: 'ServicesForm',
  props: {
    cardTitle: {
      type: String,
      default: 'إضافة'
    },
    dataRow: {
      type: Object,
      default: null,
    },
    categoryChoices: {
      type: Object,
      default: () => ({}),
    },
  },
  data(){
    return {
      formLoader: false,
      hasError: false,
      hasSucess: false,
      message: '',
      errorNumber: 0,
      name: null,
      nameEn: null,
      price: 0,
      priceFast: 0,
      isActive: true,
      isPhoto: false,
      hasHandPrice: true,
      hasPartsPrice: true,
      category: '',
    }
  },
  computed:{
    filteredCategoryChoices(){
      return this.categoryChoices;
    },
  },
  methods: {
    subimtData(){
      this.formLoader = true;
      this.hasError = false;
      this.hasSucess = false;

      if(!this.name || !this.nameEn || !this.category){
        this.message = 'كل البيانات مطلوبة'; 
        this.errorNumber = 0;
        this.hasError = true;
        window.scrollTo({ top: 0, behavior: 'smooth' });
        this.formLoader = false;
        return;
      }
      
      const payload = {
        name: this.name,
        nameEn: this.nameEn,
        price: this.price,
        priceFast: this.priceFast,
        isActive: this.isActive,
        isPhoto: this.isPhoto,
        hasHandPrice: this.hasHandPrice,
        hasPartsPrice: this.hasPartsPrice,
        category: this.category,
      }
      
      let api = null;
      if(this.dataRow)
        api = this.$http.put(`/api/admin/mIssues/update/${this.dataRow.id}`, payload);
      else
        api = this.$http.post('/api/admin/mIssues/create', payload);
      api.then(({data}) => {
        if(!this.dataRow){
          toast('تم إضافة الإعداد بنجاح', 'success');
          this.$router.replace('/mIssues').catch(() => {});
        }else{
          this.message = 'تم التعديل بنجاح';
          this.hasSucess = true;
          window.scrollTo({ top: 0, behavior: 'smooth' });
        }
        this.formLoader = false;
      }).catch(err => {
        [this.message, this.errorNumber] = this.$globalError(err, true);
        this.hasError = true;
        window.scrollTo({ top: 0, behavior: 'smooth' });
        this.formLoader = false;
      });
    },
    setImage(files){
      this.image = files[0];
    },
  },
  created(){
    if(this.dataRow){
      this.name = this.dataRow.name;
      this.nameEn = this.dataRow.nameEn;
      this.price = this.dataRow.price;
      this.priceFast = this.dataRow.priceFast;
      this.isActive = this.dataRow.isActive;
      this.isPhoto = this.dataRow.isPhoto;
      this.hasHandPrice = this.dataRow.hasHandPrice;
      this.hasPartsPrice = this.dataRow.hasPartsPrice;
      this.category = this.dataRow.category ?? 'normal';
    }
  }
}
</script>
